import { useContext } from 'react'
import { CutterContext } from '../../contexts/CutterContext'
import { useHotkey } from '../../../hooks/useHotkey'
import { AppContext } from '../../../AppContext'
import { isControlHotkey } from '../../../functions/isControlHotkey'

export function useSelectAllHotKey() {
  const { hotkeysEnabled } = useContext(AppContext)
  const { audio, setSelection } = useContext(CutterContext)

  useHotkey(
    (event) => isControlHotkey(event, 65, 'a'),
    () => setSelection([0, audio.length]),
    hotkeysEnabled,
  )
}
